import React from "react";

import {
  getTutorialStatusLabel,
  getTutorialStatusTone,
} from "../utils/tutorialAdminUtils";

const TONES = {
  green:
    "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900/50 dark:bg-emerald-500/10 dark:text-emerald-300",

  orange:
    "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900/50 dark:bg-amber-500/10 dark:text-amber-300",

  gray:
    "border-slate-200 bg-slate-100 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300",
};

export default function TutorialStatusBadge({
  status,
}) {
  const tone = getTutorialStatusTone(status);

  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${
        TONES[tone] || TONES.gray
      }`}
    >
      {getTutorialStatusLabel(status)}
    </span>
  );
}